import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

export const getAuthState = createAsyncThunk(
  'auth/checkAuthState',

  async (arg, { dispatch, getState, extra, requestId, signal, rejectWithValue }) => {
    return axios(
      `/users/status`, {
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: "POST",
        credentials: 'include',
        validateStatus: () => true,
      }).then((res) => {
        if (res.status >= 400) {
          return rejectWithValue([], "api url not found from");
        }
        else {
          return dispatch(login(res.data.data));
        }
      }).catch(error => {
        console.log(error);
        return rejectWithValue([], error);
    })
  }
)

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loadState: 'idle',
    isAuthenticated: false,
    user: null
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    logout: (state, action) => {
      state.isAuthenticated = false;
      state.user = null;
    },
    update: (state, action) => {
      state.user = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAuthState.fulfilled, (state, action) => {
      state.loadState = 'idle'
    })
    builder.addCase(getAuthState.pending, (state, action) => {
      state.loadState = 'loading'
    })
    builder.addCase(getAuthState.rejected, (state, action) => {
      state.loadState = 'idle'
    })
  }
});

export const { login, logout, update } = authSlice.actions;

export default authSlice.reducer;
